import React from "react";
import { CommunicationFeedbackFilter } from "@/services/interfaces/IFeedbackService";
import RoomFilter from "./room";
import FrontDeskFilter from "./front-desk";
import CreatedAtFilter from "./date";
import RatingFilter from "./rating";
import { useTranslation } from "react-i18next";

export interface CommunicationFeedbacksFilterProps {
  filters: Omit<
    CommunicationFeedbackFilter,
    "sortBy" | "page" | "limit" | "hotelId"
  >;
  onChange: (
    newFilters: Omit<
      CommunicationFeedbackFilter,
      "sortBy" | "page" | "limit" | "hotelId"
    >,
  ) => void;
}

const CommunicationFeedbacksFilters: React.FC<
  CommunicationFeedbacksFilterProps
> = ({ filters, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap gap-4">
      <CreatedAtFilter
        range={{
          from: filters.feedbackStartDateRange,
          to: filters.feedbackEndDateRange,
        }}
        onChange={(range) =>
          onChange({
            ...filters,
            feedbackStartDateRange: range.from,
            feedbackEndDateRange: range.to,
          })
        }
      />

      <RatingFilter
        onChange={(rating) =>
          onChange({ ...filters, minRating: parseInt(rating) })
        }
        rating={filters.minRating?.toString() || "1"}
      />

      <RoomFilter
        onChange={(ids) => onChange({ ...filters, roomIds: ids })}
        ids={filters.roomIds || []}
      />

      <FrontDeskFilter
        onChange={(ids) => onChange({ ...filters, consiergeIds: ids })}
        ids={filters.consiergeIds || []}
        placeholder={t(
          "feedbacks.filters.conciergePlaceholder",
          "Filter feedbacks by consierge",
        )}
      />
    </div>
  );
};

export default CommunicationFeedbacksFilters;
